import { Release } from '@upright/common/model/releases/types';

export function friendlyReleaseLabel(release: Release) {
  return `${release.number} (${release.maturity})`;
}
